import { displayToast } from '../../components/Toaster/displayToast';
import generateHeaders from '../myHeaders';

const createTenant = (
    name: string,
    slug: string,
    hasGlobalView: boolean,
    successMessage: string,
    errorMessage: string,
    mutate: () => void,
    selectedSchema: string,
) => {
    const url = `${process.env.REACT_APP_API_URL}/configuration/clients/`;

    const requestOptions = {
        method: 'POST',
        headers: generateHeaders(selectedSchema),
        body: JSON.stringify({ name, slug, hasGlobalView }),
    };

    return fetch(url, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');

                return undefined;
            }
            displayToast(successMessage, 'success');
            mutate();

            return response.json();
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default createTenant;
